// extracted by mini-css-extract-plugin
export default {"label":"Slider_label__KU97i","grid":"Slider_grid__zDWFk","input":"Slider_input__aEvYg","inputProps":"Slider_inputProps__McHY1"};